export const THEME = {
  EVENT_THEME: "event_theme",
  VIDEO_THEME: "video_theme",
  CHAPTER_ON_DEMAND_THEME: "chapter_on_demand_theme",
  DOUCUMENTARY_THEME: "documentary_theme",
  REELS_THEME: "reels_theme",
  EVENT_ENDED_THEME: "event_ended_theme",
  MANKIND_STANDALONE_THEME: "mankind_standalone_theme",
};
